(() => {
  const ready = () => {
    const marker = document.querySelector('[data-cx-page]');
    if (!marker || marker.dataset.ready === 'true') return;
    marker.dataset.ready = 'true';
    const root = document;

    const params = new URLSearchParams(window.location.search);
    const raw = params.get('corporate') || params.get('company') || params.get('name') || '';
    const company = raw.replace(/[+_]+/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 70);
    const display = company || 'your team';
    root.querySelectorAll('[data-cx-company]').forEach((node) => { node.textContent = display; });
    root.querySelectorAll('[data-cx-company-upper]').forEach((node) => { node.textContent = display.toUpperCase(); });
    root.querySelectorAll('[data-cx-company-input]').forEach((node) => { if (company) node.value = company; });
    root.querySelectorAll('[data-cx-tags]').forEach((node) => {
      const suffix = company ? `,corporate-${company.toLowerCase().replace(/[^a-z0-9]+/g, '-')}` : '';
      node.value = `corporate-account-lead,corporate-accounts-overview${suffix}`;
    });

    const techTabs = [...root.querySelectorAll('[data-cx-tech-tab]')];
    const techImages = [...root.querySelectorAll('[data-cx-tech-image]')];
    const techSources = [...root.querySelectorAll('[data-cx-tech-source]')];
    const techTarget = root.querySelector('[data-cx-tech-card]');
    let techIndex = -1;
    const activateTech = (index) => {
      if (index === techIndex) return;
      techIndex = index;
      techTabs.forEach((node, i) => node.classList.toggle('is-active', i === index));
      techImages.forEach((node, i) => node.classList.toggle('is-active', i === index));
      const techStage = root.querySelector('.cx-engineering__stage');
      if (techStage) techStage.dataset.active = String(index + 1);
      if (window.matchMedia('(max-width: 900px)').matches && techTabs[index]) {
        techTabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      const source = techSources[index];
      if (source && techTarget) {
        techTarget.innerHTML = source.innerHTML;
        if (typeof techTarget.animate === 'function') techTarget.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 360, easing: 'ease-out' });
      }
    };

    const systemTabs = [...root.querySelectorAll('[data-cx-system-tab]')];
    const systemCards = [...root.querySelectorAll('[data-cx-system-card]')];
    let systemIndex = -1;
    const activateSystem = (index) => {
      if (index === systemIndex) return;
      systemIndex = index;
      const systemMarker = root.querySelector('[data-cx-system-marker]');
      if (systemMarker) systemMarker.dataset.active = String(index + 1);
      const systemCardsWrap = root.querySelector('.cx-system__cards');
      if (systemCardsWrap) systemCardsWrap.dataset.active = String(index + 1);
      systemTabs.forEach((node, i) => node.classList.toggle('is-active', i === index));
      systemCards.forEach((node, i) => node.classList.toggle('is-active', i === index));
    };

    const scrollToStep = (section, index, count) => {
      if (!section || count < 1) return;
      const top = window.scrollY + section.getBoundingClientRect().top;
      const travel = Math.max(1, section.offsetHeight - window.innerHeight);
      window.scrollTo({ top: top + travel * ((index + .2) / count), behavior: 'smooth' });
    };
    const engineeringSection = root.querySelector('#engineering');
    const systemSection = root.querySelector('#how');
    techTabs.forEach((button, index) => button.addEventListener('click', () => scrollToStep(engineeringSection, index, techTabs.length)));
    systemTabs.forEach((button, index) => button.addEventListener('click', () => scrollToStep(systemSection, index, systemTabs.length)));
    activateTech(0);
    activateSystem(0);

    let stepperFrame = 0;
    const updateScrollSteppers = () => {
      stepperFrame = 0;
      [[engineeringSection, techTabs.length, activateTech], [systemSection, systemTabs.length, activateSystem]].forEach(([section, count, activate]) => {
        if (!section || !count) return;
        const rect = section.getBoundingClientRect();
        const travel = Math.max(1, rect.height - window.innerHeight);
        const progress = Math.max(0, Math.min(.9999, -rect.top / travel));
        activate(Math.min(count - 1, Math.floor(progress * count)));
      });
    };
    const requestStepperUpdate = () => {
      if (!stepperFrame) stepperFrame = window.requestAnimationFrame(updateScrollSteppers);
    };
    window.addEventListener('scroll', requestStepperUpdate, { passive: true });
    window.addEventListener('resize', requestStepperUpdate, { passive: true });
    updateScrollSteppers();

    const reviewCards = [...root.querySelectorAll('[data-cx-review]')];
    const filterReviews = (filter) => {
      reviewCards.forEach((card) => {
        const visible = filter === 'all' || (card.dataset.filters || '').split(' ').includes(filter);
        card.hidden = !visible;
      });
      const reviewStage = root.querySelector('.cx-reviews__stage');
      if (reviewStage) reviewStage.scrollTo({ left: 0, behavior: 'smooth' });
      root.querySelectorAll('[data-cx-review-filter]').forEach((node) => node.classList.toggle('is-active', node.dataset.cxReviewFilter === filter));
    };
    root.querySelectorAll('[data-cx-review-filter]').forEach((button) => button.addEventListener('click', () => filterReviews(button.dataset.cxReviewFilter)));
    filterReviews('all');

    const reviewStage = root.querySelector('.cx-reviews__stage');
    root.querySelectorAll('[data-cx-review-move]').forEach((button) => button.addEventListener('click', () => {
      if (!reviewStage) return;
      const visibleCard = reviewCards.find((card) => !card.hidden);
      const step = visibleCard ? visibleCard.getBoundingClientRect().width + 14 : reviewStage.clientWidth;
      reviewStage.scrollBy({ left: Number(button.dataset.cxReviewMove) * step, behavior: 'smooth' });
    }));

    const track = root.querySelector('[data-cx-products]');
    const productButtons = [...root.querySelectorAll('[data-cx-product-move]')];
    const productProgress = root.querySelector('[data-cx-product-progress]');
    const updateProductProgress = () => {
      if (!track) return;
      const max = Math.max(1, track.scrollWidth - track.clientWidth);
      const progress = Math.max(0, Math.min(1, track.scrollLeft / max));
      if (productProgress) productProgress.style.transform = `scaleX(${Math.max(.08, progress)})`;
      productButtons.forEach((button) => {
        const direction = Number(button.dataset.cxProductMove);
        button.disabled = direction < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
      });
    };
    productButtons.forEach((button) => button.addEventListener('click', () => {
      if (!track) return;
      const distance = Number(button.dataset.cxProductMove) * track.clientWidth * .82;
      const next = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + distance));
      track.scrollTo({ left: next, behavior: 'smooth' });
    }));
    if (track) {
      track.addEventListener('scroll', updateProductProgress, { passive: true });
      window.addEventListener('resize', updateProductProgress, { passive: true });
      updateProductProgress();
    }

    root.querySelectorAll('[data-cx-savings]').forEach((calculator) => {
      const range = calculator.querySelector('[data-cx-savings-range]');
      const team = calculator.querySelector('[data-cx-savings-team]');
      const value = calculator.querySelector('[data-cx-savings-value]');
      if (!range || !team || !value) return;
      const updateSavings = () => {
        const people = Math.max(10, Number(range.value) || 10);
        team.textContent = people.toLocaleString('en-AU');
        value.textContent = (people * 80).toLocaleString('en-AU');
        range.style.setProperty('--cx-range-progress', `${((people - 10) / 490) * 100}%`);
      };
      range.addEventListener('input', updateSavings);
      range.addEventListener('change', updateSavings);
      const updateFromPointer = (event) => {
        const rect = range.getBoundingClientRect();
        const min = Number(range.min) || 0;
        const max = Number(range.max) || 100;
        const step = Number(range.step) || 1;
        const ratio = Math.max(0, Math.min(1, (event.clientX - rect.left) / Math.max(rect.width, 1)));
        range.value = String(Math.round((min + ratio * (max - min)) / step) * step);
        updateSavings();
      };
      range.addEventListener('pointerdown', (event) => {
        range.setPointerCapture(event.pointerId);
        updateFromPointer(event);
      });
      range.addEventListener('pointermove', (event) => {
        if (range.hasPointerCapture(event.pointerId)) updateFromPointer(event);
      });
      range.addEventListener('pointerup', (event) => {
        if (range.hasPointerCapture(event.pointerId)) range.releasePointerCapture(event.pointerId);
      });
      range.addEventListener('keydown', (event) => {
        const min = Number(range.min) || 0;
        const max = Number(range.max) || 100;
        const step = Number(range.step) || 1;
        const moves = { ArrowLeft: -step, ArrowDown: -step, ArrowRight: step, ArrowUp: step, PageDown: -step * 10, PageUp: step * 10 };
        let next = Number(range.value);
        if (event.key === 'Home') next = min;
        else if (event.key === 'End') next = max;
        else if (moves[event.key]) next += moves[event.key];
        else return;
        event.preventDefault();
        range.value = String(Math.max(min, Math.min(max, next)));
        updateSavings();
      });
      updateSavings();
    });

    const autoplayVideos = [...root.querySelectorAll('.cx video[autoplay]')];
    const playVideos = () => autoplayVideos.forEach((video) => {
      video.muted = true;
      const play = video.play();
      if (play && typeof play.catch === 'function') play.catch(() => {});
    });
    playVideos();
    document.addEventListener('visibilitychange', () => { if (!document.hidden) playVideos(); });

    const parallaxItems = [...root.querySelectorAll('[data-cx-parallax]')];
    const parallaxSections = [...root.querySelectorAll('.cx')];
    if (parallaxItems.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let parallaxFrame = 0;
      const renderParallax = () => {
        parallaxFrame = 0;
        const viewport = window.innerHeight || 1;
        parallaxItems.forEach((item) => {
          const section = item.closest('.cx') || item;
          const rect = section.getBoundingClientRect();
          if (rect.bottom < -viewport * .25 || rect.top > viewport * 1.25) return;
          const mobileMotion = window.matchMedia('(max-width: 900px)').matches ? .38 : 1;
          const travel = (Number(item.dataset.cxParallax) || 0) * mobileMotion;
          const progress = (viewport / 2 - (rect.top + rect.height / 2)) / (viewport + rect.height);
          const offset = Math.max(-Math.abs(travel), Math.min(Math.abs(travel), progress * travel * 2));
          item.style.setProperty('--cx-parallax-y', `${offset.toFixed(1)}px`);
        });
        parallaxSections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          if (rect.bottom < -viewport * .25 || rect.top > viewport * 1.25) return;
          const progress = (viewport / 2 - (rect.top + rect.height / 2)) / (viewport + rect.height);
          const sectionTravel = window.matchMedia('(max-width: 900px)').matches ? 36 : 90;
          section.style.setProperty('--cx-section-shift', `${(progress * sectionTravel).toFixed(1)}px`);
        });
      };
      const requestParallax = () => {
        if (!parallaxFrame) parallaxFrame = window.requestAnimationFrame(renderParallax);
      };
      window.addEventListener('scroll', requestParallax, { passive: true });
      window.addEventListener('resize', requestParallax, { passive: true });
      renderParallax();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', ready);
})();
